module.exports = __webpack_public_path__ + "img/7.aa9ca28e.jpg";